import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { CreateOriginatorForm } from "./CreateOriginatorForm";

export const CreateOriginatorButton: React.VFC = () => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" />
            <Aside isOpen={isAsideOpen} type="form" headerText="Create Originator" onDismiss={closeAside}>
                <CreateOriginatorForm onCancel={closeAside} onSubmit={closeAside} />
            </Aside>
        </>
    );
};
